"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAgcoIdMessages = void 0;
var messages_1 = require("../../../messages");
var messages = messages_1.commonMessages.registration;
var useAgcoIdMessages = function (emailFormatValidation, registration) {
    var description = messages.createAgcoId.description;
    if (registration.otpTransactionId) {
        if (registration.otpResent) {
            description = messages.createAgcoId.verifyCodeSent;
        }
        else {
            description = messages.createAgcoId.verifyDescription;
        }
    }
    var validationMessage;
    if (emailFormatValidation) {
        validationMessage = emailFormatValidation;
    }
    else if (registration.isEmailAlreadyUsed) {
        validationMessage = messages.createAgcoId.emailAlreadyUsed;
    }
    else if (registration.emailError) {
        validationMessage = messages_1.commonMessages.general.apiError;
    }
    return { description: description, validationMessage: validationMessage };
};
exports.useAgcoIdMessages = useAgcoIdMessages;
